

define(['angular', 'text!./template.html', 'components/xo-ui-components/src/error-tooltip/directive', 'components/xo-ui-components/src/floating-label/directive'], function (angular, template) {

    return angular.module('xo-name-input.directive', ['squid', 'xo-error-tooltip.directive', 'floating-label.directive']).directive('xoNameInput', function () {

        return {
            template: template,

            scope: {
                user: '=',
                country: '@'
            },

            controller: function controller($populate, $scope, $locale, $MetadataModel) {

                $scope.locale = $locale;
                $scope.metadata = $MetadataModel.create();

                // Normalizes Griffin's address-related content for rendering.

                $scope.$watch('country', function () {
                    $scope.metadata.choose($scope.country || $locale.country, $locale.lang);
                });
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-form-components/src/name-input/directive.js
// module id = ./components/xo-form-components/src/name-input/directive.js
// module chunks = 1